<script lang="ts" setup>
const {
  closeNavigation,
} = useNavigation()
</script>

<template>
  <div class="navigation-header">
    <AppLogo class="navigation-header__logo" />

    <div class="navigation-header__entries">
    </div>

    <button
      class="navigation-header__close"
      :aria-label="$t('Close')"
      @click="closeNavigation"
    >
      <Icon name="icon:close" />
      <span class="navigation-header__close-label">{{ $t('Close') }}</span>
    </button>
  </div>
</template>

<style>
@import url("~layers/app/components/Navigation/Header.css");
</style>
